import { useEffect, useState } from "react";
import { useLocation, NavLink } from "react-router-dom";
import { Row, Col, Card } from "react-bootstrap";
import axios from "axios";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";

import { BASE_URL, security_key } from "../global";

const activityTypeMap = {
    0: "Online Activity",
    1: "My Library Video",
    2: "Diagnostics",
    3: "My Library Link",
    4: "My Library Task",
    5: "My Library Worksheet",
    6: "Video",
    7: "Worksheets",
    8: "Summative"
};

function ReportCoinActivityType() {
    const location = useLocation();
    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        sessionStorage.setItem("previousPagePathname", location.pathname);
    }, [location.pathname]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await axios.post(`${BASE_URL}API/api_index.php`, {
                security_key,
                mode: "getStudentCoinActivityTypeReport",
                fk_cent_key: sessionStorage.getItem("key"),
            });
            if (res.data.success) {
                setRecords(
                    res.data.data.map((item, index) => ({
                        id: index + 1,
                        student_name: `${item.st_first_name} ${item.st_surname}`,
                        activity_type: activityTypeMap[item.activity_type] ?? `Type ${item.activity_type}`,
                        num_activities: item.num_activities,
                        total_coins_earned: item.total_coins_earned,
                    }))
                );
            }
        } catch (err) {
            console.error("Failed to fetch coin activity type report:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const columns = [
        {
            field: "student_name",
            headerName: "Student Name",
            flex: 1,
            headerClassName: "super-app-theme--header",
        },
        {
            field: "activity_type",
            headerName: "Activity Type",
            flex: 1,
            headerClassName: "super-app-theme--header",
        },
        {
            field: "num_activities",
            headerName: "No. of Activities",
            flex: 1,
            headerClassName: "super-app-theme--header",
        },
        {
            field: "total_coins_earned",
            headerName: "Total Coins",
            flex: 1,
            headerClassName: "super-app-theme--header",
        },
    ];

    return (
        <div className="">
            <div className="mb-3 d-flex justify-content-between align-items-center">
                <div>
                    <h5 className="page-title">Student Coin Activity Type Report</h5>
                    <Breadcrumbs aria-label="breadcrumb" className="my-breadcrumbs">
                        <NavLink to="/calendar">Home</NavLink>
                        <NavLink to="/reports">Reports</NavLink>
                        <Typography color="text.primary">Coin Activity Report</Typography>
                    </Breadcrumbs>
                </div>
            </div>

            <Card className="card my-card mb-3">
                <Card.Body>
                    <Row>
                        <Col xs="12">
                            <Box
                                sx={{
                                    width: "100%",
                                    overflowX: "auto",
                                    "& .super-app-theme--header": {
                                        backgroundColor: "#f4f4f4",
                                        whiteSpace: "normal",
                                    },
                                    "& .MuiDataGrid-cell": {
                                        whiteSpace: "normal",
                                        wordWrap: "break-word",
                                    },
                                    "& .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus": {
                                        outline: "none",
                                    },
                                }}
                            >
                                <DataGrid
                                    autoHeight
                                    loading={loading}
                                    rows={records}
                                    columns={columns}
                                    pageSizeOptions={[10, 25, 50, 100]}
                                    rowHeight={60}
                                    slots={{ loadingOverlay: LinearProgress, toolbar: GridToolbar }}
                                    slotProps={{
                                        toolbar: {
                                            csvOptions: { fileName: "CoinActivityTypeReport" },
                                            printOptions: {
                                                fileName: "CoinActivityTypeReport",
                                                hideFooter: true,
                                                hideToolbar: true,
                                            },
                                            showQuickFilter: true,
                                        },
                                    }}
                                    disableRowSelectionOnClick
                                    showColumnVerticalBorder
                                    showCellVerticalBorder
                                />
                            </Box>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </div>
    );
}

export default ReportCoinActivityType;
